/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Plan_SeatsInputs */

const cs_billing_plan_seats = /** @type {(inputs: Billing_Plan_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uživatelé`)
};

const en_billing_plan_seats = /** @type {(inputs: Billing_Plan_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seats`)
};

/**
* | output |
* | --- |
* | "Seats" |
*
* @param {Billing_Plan_SeatsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_seats = /** @type {((inputs?: Billing_Plan_SeatsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_SeatsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_seats(inputs)
	return cs_billing_plan_seats(inputs)
});